// This file contains mock game data for demo purposes.
// In production, this will be replaced with API calls to the NCAABase backend.

export const ALL_CONFERENCES = [
  "SEC","Big Ten","Big 12","ACC","AAC","A-10","Big East","Big West","C-USA","Independent",
  "CAA","Horizon","Ivy","MAAC","MAC","MEAC","MVC","MWC","NEC","OVC",
  "Patriot","SoCon","Sun Belt","SWAC","Summit","WAC","WCC","Big South","ASUN","Southland",
];

export const ALL_TEAMS = [
  {name:"Alabama",abbr:"BAMA",conf:"SEC"},{name:"Arkansas",abbr:"ARK",conf:"SEC"},
  {name:"Auburn",abbr:"AUB",conf:"SEC"},{name:"Florida",abbr:"UF",conf:"SEC"},
  {name:"Georgia",abbr:"UGA",conf:"SEC"},{name:"Kentucky",abbr:"UK",conf:"SEC"},
  {name:"LSU",abbr:"LSU",conf:"SEC"},{name:"Mississippi State",abbr:"MSST",conf:"SEC"},
  {name:"Missouri",abbr:"MIZ",conf:"SEC"},{name:"Ole Miss",abbr:"MISS",conf:"SEC"},
  {name:"South Carolina",abbr:"SCAR",conf:"SEC"},{name:"Tennessee",abbr:"TENN",conf:"SEC"},
  {name:"Texas A&M",abbr:"TAMU",conf:"SEC"},{name:"Vanderbilt",abbr:"VANDY",conf:"SEC"},
  {name:"Texas",abbr:"TEX",conf:"SEC"},{name:"Oklahoma",abbr:"OU",conf:"SEC"},
  {name:"Oregon State",abbr:"ORST",conf:"Independent"},{name:"UCLA",abbr:"UCLA",conf:"Big Ten"},
  {name:"USC",abbr:"USC",conf:"Big Ten"},{name:"Michigan",abbr:"MICH",conf:"Big Ten"},
  {name:"Ohio State",abbr:"OSU",conf:"Big Ten"},{name:"Indiana",abbr:"IND",conf:"Big Ten"},
  {name:"Oregon",abbr:"ORE",conf:"Big Ten"},{name:"Washington",abbr:"UW",conf:"Big Ten"},
  {name:"Nebraska",abbr:"NEB",conf:"Big Ten"},
  {name:"TCU",abbr:"TCU",conf:"Big 12"},{name:"Texas Tech",abbr:"TTU",conf:"Big 12"},
  {name:"Oklahoma State",abbr:"OKST",conf:"Big 12"},{name:"Houston",abbr:"HOU",conf:"Big 12"},
  {name:"West Virginia",abbr:"WVU",conf:"Big 12"},{name:"Kansas State",abbr:"KSU",conf:"Big 12"},
  {name:"BYU",abbr:"BYU",conf:"Big 12"},{name:"Utah",abbr:"UTAH",conf:"Big 12"},
  {name:"Clemson",abbr:"CLEM",conf:"ACC"},{name:"Florida State",abbr:"FSU",conf:"ACC"},
  {name:"Wake Forest",abbr:"WAKE",conf:"ACC"},{name:"Virginia",abbr:"UVA",conf:"ACC"},
  {name:"Stanford",abbr:"STAN",conf:"ACC"},{name:"Duke",abbr:"DUKE",conf:"ACC"},
  {name:"Washington State",abbr:"WSU",conf:"MWC"},{name:"Air Force",abbr:"AFA",conf:"MWC"},
  {name:"Fresno State",abbr:"FRES",conf:"MWC"},
  {name:"UNC Greensboro",abbr:"UNCG",conf:"SoCon"},
  {name:"Gonzaga",abbr:"GONZ",conf:"WCC"},{name:"Hawaii",abbr:"HAW",conf:"Big West"},
  {name:"Western Kentucky",abbr:"WKU",conf:"C-USA"},
  {name:"Tarleton State",abbr:"TARL",conf:"WAC"},
  {name:"Missouri State",abbr:"MOST",conf:"MVC"},
];

export const MOCK_GAMES = [
  {
    id:"g1",status:"live",inning:9,half:"bottom",outs:2,balls:0,strikes:1,sortTime:1600,
    away:{name:"Michigan",abbr:"MICH",rank:null,record:"3-0",conf:"Big Ten",score:4,hits:11,errors:1,
      lineScore:[0,0,0,0,1,0,2,1,0]},
    home:{name:"Oregon State",abbr:"ORST",rank:12,record:"2-1",conf:"Independent",score:4,hits:8,errors:1,
      lineScore:[0,0,0,2,1,0,1,0,null]},
    runners:{first:true,second:false,third:false},
    pitcher:{name:"T. Reynolds",throws:"R",pitchCount:24},
    hitter:{name:"J. Proctor",bats:"L",avg:".333"},
    winProb:{away:50,home:50},venue:"Surprise Stadium",startTime:"4:00 PM ET",
  },
  {
    id:"g2",status:"live",inning:9,half:"bottom",outs:1,balls:0,strikes:0,sortTime:1400,
    away:{name:"BYU",abbr:"BYU",rank:null,record:"1-2",conf:"Big 12",score:12,hits:16,errors:1,
      lineScore:[0,5,0,4,2,0,0,1,0]},
    home:{name:"Western Kentucky",abbr:"WKU",rank:null,record:"2-1",conf:"C-USA",score:7,hits:7,errors:1,
      lineScore:[0,1,4,1,0,0,0,1,null]},
    runners:{first:false,second:false,third:false},
    pitcher:{name:"C. Allen",throws:"R",pitchCount:18},
    hitter:{name:"M. Davis",bats:"R",avg:".250"},
    winProb:{away:95,home:5},venue:"Nick Denes Field",startTime:"2:00 PM ET",
  },
  {
    id:"g3",status:"live",inning:6,half:"top",outs:1,balls:1,strikes:2,sortTime:1600,
    away:{name:"Houston",abbr:"HOU",rank:null,record:"2-0",conf:"Big 12",score:3,hits:7,errors:0,
      lineScore:[0,1,0,2,0,null,null,null,null]},
    home:{name:"Washington",abbr:"UW",rank:null,record:"0-2",conf:"Big Ten",score:1,hits:4,errors:1,
      lineScore:[0,0,0,1,0,null,null,null,null]},
    runners:{first:false,second:true,third:false},
    pitcher:{name:"R. Santos",throws:"L",pitchCount:71},
    hitter:{name:"K. Webb",bats:"R",avg:".286"},
    winProb:{away:78,home:22},venue:"Ponce, PR",startTime:"4:00 PM ET",
  },
  {
    id:"g4",status:"live",inning:4,half:"bottom",outs:0,balls:2,strikes:0,sortTime:1600,
    away:{name:"Kansas State",abbr:"KSU",rank:null,record:"2-1",conf:"Big 12",score:0,hits:2,errors:0,
      lineScore:[0,0,0,null,null,null,null,null,null]},
    home:{name:"Air Force",abbr:"AFA",rank:null,record:"1-2",conf:"MWC",score:2,hits:5,errors:0,
      lineScore:[0,1,1,null,null,null,null,null,null]},
    runners:{first:false,second:false,third:false},
    pitcher:{name:"C. Liggett",throws:"R",pitchCount:48},
    hitter:{name:"D. Trent",bats:"L",avg:".200"},
    winProb:{away:35,home:65},venue:"Sloan Park",startTime:"4:00 PM ET",
  },
  {
    id:"g5",status:"live",inning:5,half:"top",outs:2,balls:1,strikes:1,sortTime:1600,
    away:{name:"Stanford",abbr:"STAN",rank:null,record:"1-2",conf:"ACC",score:2,hits:6,errors:0,
      lineScore:[0,0,1,1,null,null,null,null,null]},
    home:{name:"Nebraska",abbr:"NEB",rank:null,record:"2-1",conf:"Big Ten",score:3,hits:5,errors:1,
      lineScore:[0,2,0,1,null,null,null,null,null]},
    runners:{first:true,second:true,third:false},
    pitcher:{name:"B. Fischer",throws:"R",pitchCount:62},
    hitter:{name:"J. Kim",bats:"L",avg:".375"},
    winProb:{away:40,home:60},venue:"Scottsdale, AZ",startTime:"4:00 PM ET",
  },
  {
    id:"g6",status:"live",inning:3,half:"bottom",outs:1,balls:0,strikes:2,sortTime:1700,
    away:{name:"Arkansas",abbr:"ARK",rank:6,record:"2-1",conf:"SEC",score:2,hits:4,errors:0,
      lineScore:[1,1,null,null,null,null,null,null,null]},
    home:{name:"Tarleton State",abbr:"TARL",rank:null,record:"1-2",conf:"WAC",score:0,hits:1,errors:0,
      lineScore:[0,0,null,null,null,null,null,null,null]},
    runners:{first:false,second:false,third:false},
    pitcher:{name:"H. Hogan",throws:"R",pitchCount:38},
    hitter:{name:"R. Flores",bats:"R",avg:".143"},
    winProb:{away:92,home:8},venue:"Globe Life Field",startTime:"5:00 PM ET",
  },
  {
    id:"g7",status:"live",inning:2,half:"top",outs:0,balls:3,strikes:1,sortTime:1700,
    away:{name:"Utah",abbr:"UTAH",rank:null,record:"1-2",conf:"Big 12",score:0,hits:0,errors:0,
      lineScore:[0,null,null,null,null,null,null,null,null]},
    home:{name:"Fresno State",abbr:"FRES",rank:null,record:"3-0",conf:"MWC",score:1,hits:2,errors:0,
      lineScore:[1,null,null,null,null,null,null,null,null]},
    runners:{first:false,second:false,third:false},
    pitcher:{name:"L. Tanaka",throws:"L",pitchCount:22},
    hitter:{name:"A. Reyes",bats:"R",avg:".000"},
    winProb:{away:38,home:62},venue:"Pete Beiden Field",startTime:"5:00 PM ET",
  },
  {
    id:"g8",status:"pre",inning:0,half:"top",outs:0,balls:0,strikes:0,sortTime:1805,
    away:{name:"N.C. A&T",abbr:"NCAT",rank:null,record:"0-2",conf:"CAA",score:0,hits:0,errors:0,
      lineScore:[null,null,null,null,null,null,null,null,null]},
    home:{name:"NIIT",abbr:"NILL",rank:null,record:"2-0",conf:"SoCon",score:0,hits:0,errors:0,
      lineScore:[null,null,null,null,null,null,null,null,null]},
    runners:{first:false,second:false,third:false},pitcher:null,hitter:null,
    winProb:{away:35,home:65},venue:"Greensboro, NC",startTime:"6:05 PM ET",
  },
  {
    id:"g9",status:"pre",inning:0,half:"top",outs:0,balls:0,strikes:0,sortTime:1900,
    away:{name:"Gonzaga",abbr:"GONZ",rank:null,record:"2-1",conf:"WCC",score:0,hits:0,errors:0,
      lineScore:[null,null,null,null,null,null,null,null,null]},
    home:{name:"Hawaii",abbr:"HAW",rank:null,record:"1-2",conf:"Big West",score:0,hits:0,errors:0,
      lineScore:[null,null,null,null,null,null,null,null,null]},
    runners:{first:false,second:false,third:false},pitcher:null,hitter:null,
    winProb:{away:45,home:55},venue:"Les Murakami Stadium",startTime:"7:05 PM ET",
  },
  {
    id:"g10",status:"final",inning:7,half:"bottom",outs:3,balls:0,strikes:0,sortTime:1500,
    away:{name:"TCU",abbr:"TCU",rank:7,record:"2-1",conf:"Big 12",score:4,hits:8,errors:0,
      lineScore:[2,0,0,1,0,0,1]},
    home:{name:"Oklahoma",abbr:"OU",rank:null,record:"3-0",conf:"SEC",score:5,hits:10,errors:1,
      lineScore:[0,0,3,0,0,0,2]},
    runners:{first:false,second:false,third:false},pitcher:null,hitter:null,
    winProb:{away:0,home:100},venue:"Globe Life Field",startTime:"3:00 PM ET",
    wp:{name:"C. Rager",record:"1-0"},lp:{name:"T. Phenow",record:"0-1"},sv:null,
  },
  {
    id:"g11",status:"final",inning:10,half:"bottom",outs:3,balls:0,strikes:0,sortTime:1300,
    away:{name:"Arkansas",abbr:"ARK",rank:6,record:"2-0",conf:"SEC",score:5,hits:9,errors:0,
      lineScore:[0,0,0,1,2,0,0,0,1,1]},
    home:{name:"Missouri State",abbr:"MOST",rank:null,record:"2-1",conf:"MVC",score:4,hits:7,errors:1,
      lineScore:[0,1,0,0,2,0,1,0,0,0]},
    runners:{first:false,second:false,third:false},pitcher:null,hitter:null,
    winProb:{away:100,home:0},venue:"Globe Life Field",startTime:"11:00 AM ET",
    wp:{name:"B. Smith",record:"1-0"},lp:{name:"J. Flora",record:"0-1"},sv:null,
  },
];
